import React from "react";

const About = () => {
  return (
    <section class="about" aria-labelledby="about-label">
      <div class="container">
        <figure class="about-banner">
          <img
            src="./assets/images/about-banner.png"
            width="800"
            height="580"
            loading="lazy"
            alt="about banner"
            class="w-100"
          />
        </figure>

        <div class="about-content">
          <p class="section-subtitle" id="about-label">
            Why Choose Us?
          </p>

          <h2 class="h2 section-title">
            We provide reliable and comfortable taxi services for every journey.
          </h2>

          <ul>
            <li class="about-item">
              <div class="accordion-card expanded" data-accordion>
                <h3 class="card-title">
                  <button class="accordion-btn" data-accordion-btn>
                    <ion-icon
                      name="chevron-down-outline"
                      aria-hidden="true"
                      class="down"
                    ></ion-icon>

                    <span class="span h5">Experienced Drivers</span>
                  </button>
                </h3>

                <p class="accordion-content">
                  Our drivers are highly experienced and knowledgeable about the
                  local area, ensuring you get to your destination safely and
                  quickly.
                </p>
              </div>
            </li>

            <li class="about-item">
              <div class="accordion-card" data-accordion>
                <h3 class="card-title">
                  <button class="accordion-btn" data-accordion-btn>
                    <ion-icon
                      name="chevron-down-outline"
                      aria-hidden="true"
                      class="down"
                    ></ion-icon>

                    <span class="span h5">24/7 Availability</span>
                  </button>
                </h3>

                <p class="accordion-content">
                  No matter the time of day, our taxi services are available
                  24/7 to ensure you can get to your destination whenever you
                  need.
                </p>
              </div>
            </li>

            <li class="about-item">
              <div class="accordion-card" data-accordion>
                <h3 class="card-title">
                  <button class="accordion-btn" data-accordion-btn>
                    <ion-icon
                      name="chevron-down-outline"
                      aria-hidden="true"
                      class="down"
                    ></ion-icon>

                    <span class="span h5">Affordable Pricing</span>
                  </button>
                </h3>

                <p class="accordion-content">
                  We offer affordable and competitive pricing with no hidden
                  fees. What you see is what you pay.
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default About;
